<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-sm-8 col-lg-6 col-xl-5">
            <div class="box__cont">
                <div [ngClass]="isNotValidInputs ? '' : 'box__title--otp'" class="box__title">
                    <h1>Web Authentication</h1>
                    <h2>Enter the 6-digit code from your authenticator app.</h2>
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">The input fields are incomplete.</h3>
                </div>
                <div class="box__form">
                    <div [class.error]="isError" class="col-12 box__field box__field--otp">
                        <ng-otp-input (onInputChange)="onOtpChange($event)"
                                      [config]="{length: 6,
                                                allowNumbersOnly: true,
                                                inputClass: 'red',
                                                containerClass: 'f-form_input'}">
                        </ng-otp-input>
                    </div>

                    <div *ngIf="isInvalidCode" class="col-12 box__field box__field--otp text-center">
                        <h3 class="box__error-notif">{{ invalidText }}</h3>
                    </div>

                    <div class="row justify-content-center">
                        <div class="d-sm-none col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back"
                                            componentClass="btn-submit"
                                            (on-click)="goToForgotPassword()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Back"
                                            componentClass="btn-submit"
                                            (on-click)="goToForgotPassword()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
